import { render, staticRenderFns } from "./ContactAddressSummaryWidget.vue?vue&type=template&id=1c8bb27e&scoped=true&"
import script from "./ContactAddressSummaryWidget.vue?vue&type=script&lang=js&"
export * from "./ContactAddressSummaryWidget.vue?vue&type=script&lang=js&"
import style0 from "./ContactAddressSummaryWidget.vue?vue&type=style&index=0&id=1c8bb27e&scoped=true&lang=css&"
import style1 from "./ContactAddressSummaryWidget.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8bb27e",
  null
  
)

export default component.exports